export interface ErrorDataResponse {
  status: number;
  detail: string;
  title: string;
  instance?: string;
}

export const ReasonPhrases = Object.freeze({
  Unknown: 'Unknown',
  Unauthorized: 'Unauthorized',
  Forbidden: 'Forbidden',
  NotFound: 'NotFound',
  InternalError: 'InternalError',
  ServerFaults: 'EksMyKeysApiException',
});

export const ServerFaults = Object.freeze({
  DeviceNotFoundException: 'DeviceNotFoundException',
  NoDevicesMeetsCriteriaException: 'NoDevicesMeetsCriteriaException',
  CouldNotProcessAllItemsException: 'CouldNotProcessAllItemsException',
  OnlyDevicesForOneCustomerIsAllowedException:
    'OnlyDevicesForOneCustomerIsAllowedException',
  UserNotFoundException: 'UserNotFoundException',
  UserExistsException: 'UserExistsException',
  UserLoginServerBlockedException: 'UserLoginServerBlockedException',
});

export const ErrorDataResponseDefault: ErrorDataResponse = {
  status: 666,
  detail: 'Unknown Error',
  title: ReasonPhrases.Unknown,
};

export const Error401: ErrorDataResponse = {
  status: 401,
  detail: 'Unauthorized',
  title: ReasonPhrases.Unauthorized,
};

export const Error403: ErrorDataResponse = {
  status: 403,
  detail: 'Forbidden',
  title: ReasonPhrases.Forbidden,
};

export const Error404: ErrorDataResponse = {
  status: 404,
  detail: 'NotFound',
  title: ReasonPhrases.NotFound,
};

export const Error500: ErrorDataResponse = {
  status: 500,
  detail: 'InternalError',
  title: ReasonPhrases.InternalError,
};

export const IsUserNotFound = (res: ErrorDataResponse) =>
  res.title === ReasonPhrases.ServerFaults &&
  res.detail.startsWith(ServerFaults.UserNotFoundException);

export const UserExists = (res: ErrorDataResponse) =>
  res.title === ReasonPhrases.ServerFaults &&
  res.detail.startsWith(ServerFaults.UserExistsException);

export const UserLoginServerBlocked = (res: ErrorDataResponse) =>
  res.title === ReasonPhrases.ServerFaults &&
  res.detail.startsWith(ServerFaults.UserLoginServerBlockedException);
